import React, {ReactNode} from "react";

import styles from "./BrandHeader.scss";

type BrandHeaderProps = {
  children: ReactNode;
  id?: string;
};

export default function BrandHeader({
  children,
  id,
}: BrandHeaderProps): JSX.Element {
  return (
    <h2 id={id} className={styles.heading}>
      {children}
    </h2>
  );
}
